/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * Provider EventDispatcher
 *
 * @export
 * @class EventDispatcher
 * @template E
 */
export class EventDispatcher {
    constructor() {
        this.eventHandlers = [];
    }
    /**
     * fires event handler
     *
     * @param {E} event
     * @memberof EventDispatcher
     */
    fire(event) {
        for (const handler of this.eventHandlers) {
            handler(event);
        }
    }
    /**
     * adds eventHandler
     *
     * @param {EventHandler<E>} eventHandler
     * @memberof EventDispatcher
     */
    add(eventHandler) {
        this.eventHandlers.push(eventHandler);
    }
    /**
     * removes eventHandler
     *
     * @param {EventHandler<E>} eventHandler
     * @memberof EventDispatcher
     */
    remove(eventHandler) {
        for (let i = 0; i < this.eventHandlers.length; i++) {
            if (this.eventHandlers[i] === eventHandler) {
                this.eventHandlers.splice(i, 1);
                i--;
            }
        }
    }
}
//# sourceMappingURL=EventDispatcher.js.map